export const FETCH_FORM_POSTPROCESSORS_REQUEST =
  'formPostprocessorsTypes/FETCH_FORM_POSTPROCESSORS_REQUEST'
export const FETCH_FORM_POSTPROCESSORS_SUCCESS =
  'formPostprocessorsTypes/FETCH_FORM_POSTPROCESSORS_SUCCESS'
export const FETCH_FORM_POSTPROCESSORS_FAILURE =
  'formPostprocessorsTypes/FETCH_FORM_POSTPROCESSORS_FAILURE'

export const FETCH_FORM_POSTPROCESSOR_REQUEST =
  'formPostprocessorsTypes/FETCH_FORM_POSTPROCESSOR_REQUEST'
export const FETCH_FORM_POSTPROCESSOR_SUCCESS =
  'formPostprocessorsTypes/FETCH_FORM_POSTPROCESSOR_SUCCESS'
export const FETCH_FORM_POSTPROCESSOR_FAILURE =
  'formPostprocessorsTypes/FETCH_FORM_POSTPROCESSOR_FAILURE'

export const DELETE_FORM_POSTPROCESSOR_REQUEST =
  'formPostprocessorsTypes/DELETE_FORM_POSTPROCESSOR_REQUEST'
export const DELETE_FORM_POSTPROCESSOR_SUCCESS =
  'formPostprocessorsTypes/DELETE_FORM_POSTPROCESSOR_SUCCESS'
export const DELETE_FORM_POSTPROCESSOR_FAILURE =
  'formPostprocessorsTypes/DELETE_FORM_POSTPROCESSOR_FAILURE'

export const CREATE_FORM_POSTPROCESSOR_REQUEST =
  'formPostprocessorsTypes/CREATE_FORM_POSTPROCESSOR_REQUEST'
export const CREATE_FORM_POSTPROCESSOR_SUCCESS =
  'formPostprocessorsTypes/CREATE_FORM_POSTPROCESSOR_SUCCESS'
export const CREATE_FORM_POSTPROCESSOR_FAILURE =
  'formPostprocessorsTypes/CREATE_FORM_POSTPROCESSOR_FAILURE'

export const UPDATE_FORM_POSTPROCESSOR_REQUEST =
  'formPostprocessorsTypes/UPDATE_FORM_POSTPROCESSOR_REQUEST'
export const UPDATE_FORM_POSTPROCESSOR_SUCCESS =
  'formPostprocessorsTypes/UPDATE_FORM_POSTPROCESSOR_SUCCESS'
export const UPDATE_FORM_POSTPROCESSOR_FAILURE =
  'formPostprocessorsTypes/UPDATE_FORM_POSTPROCESSOR_FAILURE'

export const UPDATE_FIELD = 'formPostprocessorsTypes/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'formPostprocessorsTypes/SET_DEFAULT_DATA'
